import { render } from "./layout3.vue?vue&type=template&id=cb5ea15c&scoped=true"
import script from "./layout3.vue?vue&type=script&lang=js"
export * from "./layout3.vue?vue&type=script&lang=js"

import "./layout3.vue?vue&type=style&index=0&id=cb5ea15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5ea15c"]])

export default __exports__